import { formatOptionActionLabel } from '../../../../../shared/js/options-utils'
import Dialog from '../../shared/Dialog'
import React, { useState } from 'react'
import type { ProductOptionWithNameProps } from '../../../../../shared/js/Module'
import type { ReactNode, SyntheticEvent } from 'react'

interface ButtonExtendedProps extends ProductOptionWithNameProps {
  onCancel: Function
  onSubmit?: Function
  children: ReactNode
}

const Button = ({
  children,
  details,
  disabled,
  id,
  label,
  name,
  onCancel,
  onChange,
  // Optionnal function that should be called on option valiation (ie. modal
  // dismiss or validation)
  onSubmit,
  values: [value],
  valid,
}: ButtonExtendedProps) => {
  const [active, setActive] = useState(false)

  const ctaLabel = formatOptionActionLabel(label, {
    ...value,
    updateMode: value?.selected,
  })

  const actions = (
    <div className='right-action-modal__btn'>
      <button
        className='lb-btn lb-btn-type-6'
        type='reset'
        onClick={handleCancel}
      >
        Annuler
      </button>
      <button
        className='lb-btn lb-btn-type-1'
        onClick={handleValidate}
        disabled={!valid}
      >
        Appliquer
      </button>
    </div>
  )

  return (
    <>
      <button
        className='lb-btn lb-btn-type-1a panel-btn option-button'
        disabled={disabled}
        onClick={toggleDialog}
      >
        {ctaLabel}
      </button>

      {children && (
        <Dialog
          className='right-action-modal'
          onCancel={handleDialogClose}
          opened={active}
          title={label}
          actions={actions}
        >
          {details && (
            <span className='c-contextual-information u-txt-center'>
              {details}
            </span>
          )}
          {children}
        </Dialog>
      )}
    </>
  )

  function toggleDialog(event: SyntheticEvent) {
    event.preventDefault()
    if (!active) {
      onChange?.(id, [{ ...value, selected: !active }])
    }
    setActive(!active)
  }

  // When values are valid run option storage
  function handleDialogClose(event: SyntheticEvent) {
    valid ? handleValidate(event) : handleCancel()
  }

  // L'appel vide à `onChange` déclenche la réinitialisation de l’état de
  // l’option
  function handleCancel() {
    setActive(!active)
    onCancel(id)
    onSubmit?.()
  }

  function handleValidate(event: SyntheticEvent) {
    toggleDialog(event)
    onSubmit?.()
  }
}

export default Button
